// @ts-nocheck
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  HashRouter,
  useLocation,
  BrowserRouter,
} from 'react-router-dom';
import { useTheme } from '@mui/material';
import UserConfirmationPrompt from '../components/Common/UserConfirmationPrompt';
import { CoreUtils } from '../utils/Utils';

import Login from '../pages/Login';
import Organization from '../pages/Organization';
import Layout from '../pages/Layout';
import PageNotFound from '../pages/PageNotFound';
import PageLevelLoader from '../components/Common/PageLevelLoader';

const key = 'REALM_ID'; // The key you're checking for

const PrivateRoute = ({ component: Component, isLoggedIn, loading }) => (
  <Route
    render={(props) => {
      if (
        isLoggedIn &&
        window.CONFIG.REACT_APP_KEYCLOAK_LOGIN &&
        localStorage.getItem(key) !== null &&
        loading
      ) {
        return <PageLevelLoader />;
      }
      if (!isLoggedIn) {
        if (
          window.CONFIG.REACT_APP_KEYCLOAK_LOGIN &&
          localStorage.getItem(key) === null
        ) {
          return <Redirect to="/org" />;
        }
        return <Redirect to="/login" />;
      }
      return <Component {...props} loading={loading} />;
    }}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export const AppRoutes = ({ loading, isLoggedIn }) => {
  const { userConfirmationPrompt } = UserConfirmationPrompt(useTheme());
  return (
    <BrowserRouter>
      <React.Suspense fallback={<PageLevelLoader />}>
        <Switch>
          {!isLoggedIn && window.CONFIG.REACT_APP_KEYCLOAK_LOGIN && (
            <Route path="/org" component={Organization} />
          )}
          {!isLoggedIn && window.CONFIG.REACT_APP_KEYCLOAK_LOGIN && (
            <Route path="/login" render={() => <Redirect to="/org" />} />
          )}
          {/* <Route path="/org" component={Organization} />
          <Route path="/login" component={Login} /> */}

          <PrivateRoute
            path="/*"
            isLoggedIn={isLoggedIn}
            component={Layout}
            loading={loading}
          />
          <Route
            path="*"
            name="Not Found"
            render={(props) => <PageNotFound {...props} />}
          />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};
